import {LocalizationProvider} from "@mui/x-date-pickers/LocalizationProvider";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import {DatePicker} from "@mui/x-date-pickers/DatePicker";
import {TextField} from "@mui/material";
import React from "react";
import {ruRU} from "@mui/x-date-pickers/locales";

const DateInput = ({value, setValue, helperText, variant, disabled}) => {

    const handleChange = newValue => {
        setValue(newValue);
    };

    return (
        <div>
            <LocalizationProvider
                dateAdapter={AdapterDayjs}
                adapterLocale='ru'
                localeText={ruRU.components.MuiLocalizationProvider.defaultProps.localeText}>
                <DatePicker
                    disabled={disabled}
                    onChange={handleChange}
                    sx={{
                        "& .MuiInputBase-root": {
                            height: '43px'
                        }
                    }}
                    slotProps={{
                        actionBar: {
                            actions: ['clear', 'today'],
                        },
                    }}
                    onAccept={(newDate) => {
                        handleChange(newDate);
                    }}
                    ampm={false}
                    renderInput={params => (
                        <TextField
                            {...params}
                            helperText={helperText ? helperText : null}
                            sx={{maxWidth: '150px'}}
                            variant={variant ? variant : 'standard'}
                            size={"small"}
                        />
                    )}
                    value={value}
                    inputFormat="DD/MM/YYYY"
                />
            </LocalizationProvider>
        </div>
    );
};

export default DateInput;